import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import ky from 'ky';
import { isJsonApiSuccessResponse } from '@your-org/core-lib/api/json-api';
export var fetchPoemsWithKy = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", ky.get('/api/rest/poem', {
              throwHttpErrors: true
            }).json().then(function (resp) {
              if (!isJsonApiSuccessResponse(resp)) {
                throw new Error("Error fetching poems: ".concat(resp.errors));
              }

              return resp.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchPoemsWithKy() {
    return _ref.apply(this, arguments);
  };
}();